import React from 'react';
import { get, post, put, del } from '../../Utility/Http';
import Config from '../../../Utility/Config';
import { login, currentUser, forcePasswordChangeGet, forgotPasswordGet, changePasswordGet, rolePermissionApi, getVersionListGet, userOrganisationListGet, verifyMfaOtpPost, resendOtpGet, verifyOtpPost, mfaAssignPut, associateSoftwareTokenPut, verifySoftwareTokenPut, getAllTabGridLableGet } from '../Model/LoginModel';

export const loginGetApi = async (data) => {
    const response = await post(`${Config.extendedUrl}users/login`, data, null);
    return login(response);
};
export const getCurrentUser = async () => {
    const response = await get(`${Config.extendedUrl}users/currentuser`);
    return currentUser(response);
};
export const rolePermissionGetApi = async (data) => {
    const response = await get(`${Config.extendedUrl}generic/roles_permissions`, data);
    return rolePermissionApi(response);
};

export const forcePasswordChange = async (data, headers) => {
    const response = await post(`${Config.extendedUrl}users/userforcepasswordchange`, data, headers);
    return forcePasswordChangeGet(response);
};
export const forgotPassword = async (data) => {
    const response = await put(`${Config.extendedUrl}users/forgotpassword`, data, null);
    return forgotPasswordGet(response);
};
export const changePassword = async (data) => {
    const response = await put(`${Config.extendedUrl}users/confirmforgotpassword`, data, null);
    return changePasswordGet(response);
};
export const getVersionList = async (data) => {
    const response = await get(`${Config.extendedUrl}version`, data);
    return getVersionListGet(response);
};
export const userOrganisationGet = async () => {
    const response = await get(`${Config.extendedUrl}users/user_details`, null);
    return userOrganisationListGet(response);
};
export const verifyMfaOtp = async (data) => {
    const response = await post(`${Config.extendedUrl}users/mfa/verify`, data);
    return verifyMfaOtpPost(response);
};
export const resendOtp = async (data) => {
    const response = await put(`${Config.extendedUrl}users/resend_confirmation`, data);
    return resendOtpGet(response);
};
export const verifyOtp = async (data) => {
    const response = await post(`${Config.extendedUrl}users/confirm_signup`, data);
    return verifyOtpPost(response);
};
export const mfaAssign = async (data) => {
    const response = await put(`${Config.extendedUrl}users/usr_mfa_assign`, data);
    return mfaAssignPut(response);
};
export const associateSoftwareToken = async (data) => {
    const response = await put(`${Config.extendedUrl}users/associate_software_token`, data);
    return associateSoftwareTokenPut(response);
};
export const verifySoftwareToken = async (data) => {
    const response = await put(`${Config.extendedUrl}users/verify_software_token`, data);
    return verifySoftwareTokenPut(response);
};
export const getAllTabGridLable = () => {
    return get(`${Config.extendedUrl}ui-customization-defaults`).then((response) => {
        return getAllTabGridLableGet(response)
    })
};
